/* ==========================================================================
   MSS TEST — installed quote form

   Reads the machine and configuration out of the query string and writes them
   into the form's hidden inputs, plus a visible summary so the customer can see
   what they are asking about. Nothing else on the page depends on this; if it
   fails, the form still submits with everything the customer typed.
   ========================================================================== */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var form = document.getElementById('mss-quote-form');
    if (!form) return;

    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return;
    }

    var routeLabels = {
      'installed-quotation': 'Machine, installation and commissioning',
      'ready-to-trade': 'Machine, installation and commissioning',
      'fully-supported': 'Machine, installation and ongoing service plan'
    };

    var values = {
      machine: params.get('product') || '',
      configuration: params.get('configuration') || '',
      colour: params.get('colour') || '',
      route: params.get('route') || '',
      quantity: params.get('quantity') || ''
    };

    if (values.route) {
      values.route = routeLabels[values.route] || values.route;
    }

    values.source = document.referrer || '';

    // Hidden inputs, and the quantity field which is visible and editable.
    Object.keys(values).forEach(function (key) {
      var field = form.querySelector('[data-mss-quote-field="' + key + '"]');
      if (!field || !values[key]) return;
      field.value = values[key];
    });

    // Visible summary — only the rows we actually have.
    var summary = form.querySelector('[data-mss-quote-summary]');
    if (!summary) return;

    var shown = 0;
    ['machine', 'configuration', 'colour', 'route'].forEach(function (key) {
      if (!values[key]) return;
      var row = summary.querySelector('[data-mss-summary-row="' + key + '"]');
      var cell = summary.querySelector('[data-mss-summary-value="' + key + '"]');
      if (!row || !cell) return;
      cell.textContent = values[key];
      row.hidden = false;
      shown += 1;
    });

    if (shown > 0) summary.hidden = false;
  });
})();
